import React from 'react';
import classNames from 'classnames';
import './GpioInfo.less';
import {GPIO_MODES, GPIO_STATUSES} from '../../../modules/common/consts';
import {GPIO_STATUS_TRANSLATIONS, GPIO_MODE_TRANSLATIONS} from '../../../modules/common/translations';
import type {GpioStatus, GpioMode} from '../../../modules/common/types';
import '../../../modules/common/types';
type Props = {
	index: number;
	mode?: GpioMode;
	status?: GpioStatus;
	dataTestId?: string;
};

const Bubble = ({index}: {index: number}) => <div className="bubble">{index}</div>;

const Status = ({status}: {status?: GpioStatus}) => {
	return (
		<div className="status">
			{GPIO_STATUS_TRANSLATIONS[typeof status === 'boolean' ? status.toString() : 'unknown']}
		</div>
	);
};

const Mode = ({mode}: {mode?: GpioMode}) => {
	return (
		<div className="mode">
			<span>{GPIO_MODE_TRANSLATIONS[mode || 'unknown']}</span>
		</div>
	);
};

const GpioInfo = ({index, mode, status, dataTestId = 'gpio-info'}: Props) => {
	const classes = classNames('floorplan-gpio-info', {
		output: mode === GPIO_MODES.OUTPUT,
		input: mode === GPIO_MODES.INPUT,
		high: status === GPIO_STATUSES.HIGH,
		low: status === GPIO_STATUSES.LOW
	});
	return (
		<div className={classes} data-testid={dataTestId}>
			<Bubble index={index} />
			<Status status={status} />
			<Mode mode={mode} />
		</div>
	);
};

export default GpioInfo;
